function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "8base-cli-login_svg__a",
  x1: "50%",
  x2: "50%",
  y1: "100%",
  y2: ".036%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "gray",
  stopOpacity: 0.25
}), React.createElement("stop", {
  offset: "54%",
  stopColor: "gray",
  stopOpacity: 0.12
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "gray",
  stopOpacity: 0.1
})), React.createElement("linearGradient", {
  id: "8base-cli-login_svg__b",
  x1: "50%",
  x2: "50%",
  y1: "99.957%",
  y2: "0%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "gray",
  stopOpacity: 0.25
}), React.createElement("stop", {
  offset: "54%",
  stopColor: "gray",
  stopOpacity: 0.12
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "gray",
  stopOpacity: 0.1
})), React.createElement("linearGradient", {
  id: "8base-cli-login_svg__c",
  x1: "49.972%",
  x2: "49.972%",
  y1: "99.913%",
  y2: "-.087%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "gray",
  stopOpacity: 0.25
}), React.createElement("stop", {
  offset: "54%",
  stopColor: "gray",
  stopOpacity: 0.12
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "gray",
  stopOpacity: 0.1
})), React.createElement("linearGradient", {
  id: "8base-cli-login_svg__d",
  x1: "50.289%",
  x2: "50.289%",
  y1: "99.999%",
  y2: ".187%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "gray",
  stopOpacity: 0.25
}), React.createElement("stop", {
  offset: "54%",
  stopColor: "gray",
  stopOpacity: 0.12
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "gray",
  stopOpacity: 0.1
})));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", null, React.createElement("path", {
  fill: "#323C47",
  fillRule: "nonzero",
  d: "M36.29 155.84a34.98 34.98 0 0 0 6.925-.093c25.28-2.795 59.705-2 87.768 15.388 38.81 24.043 99.632 3.46 126.462-7.737 20.5-8.553 31.143-29.5 24.75-49.163-.09-.278-.182-.555-.28-.832-4.022-11.686-11.962-20.83-21.795-25.678-8.57-4.225-21.082-13.047-26.65-30-2.3-7-5.455-13.585-9.552-19.325C212.945 23.028 189.975.135 150.47.277a63.684 63.684 0 0 0-20.352 3.446C115.685 8.64 102.65 18.637 92.71 32.498c-6.342 8.84-15.847 17.057-29.455 17.727-18.885.935-36.907 9.727-50.427 25.375-.39.45-.775.903-1.16 1.36-24.073 28.678-7.353 76.085 24.622 78.88z"
}), React.createElement("circle", {
  cx: 3.615,
  cy: 3.578,
  r: 3.45,
  fill: "url(#8base-cli-login_svg__a)",
  fillRule: "nonzero",
  opacity: 0.7,
  transform: "translate(66 146)"
}), React.createElement("circle", {
  cx: 69.615,
  cy: 149.577,
  r: 3.295,
  fill: "#000",
  fillRule: "nonzero",
  opacity: 0.2
}), React.createElement("circle", {
  cx: 51.028,
  cy: 82.285,
  r: 1.275,
  fill: "#FFF",
  fillRule: "nonzero"
}), React.createElement("circle", {
  cx: 142.028,
  cy: 156.285,
  r: 1.275,
  fill: "#FFF",
  fillRule: "nonzero"
}), React.createElement("circle", {
  cx: 88.278,
  cy: 162.785,
  r: 1,
  fill: "#FFF",
  fillRule: "nonzero"
}), React.createElement("circle", {
  cx: 246.028,
  cy: 128.285,
  r: 1,
  fill: "#FFF",
  fillRule: "nonzero"
}), React.createElement("circle", {
  cx: 205.278,
  cy: 64.285,
  r: 1,
  fill: "#FFF",
  fillRule: "nonzero"
}), React.createElement("circle", {
  cx: 263.027,
  cy: 95.535,
  r: 1,
  fill: "#FFF",
  fillRule: "nonzero"
}), React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M38.485 126.802H37.35v-1.134h-.462v1.134h-1.136v.463h1.136v1.133h.462v-1.133h1.135zM66.985 126.302H65.85v-1.134h-.462v1.134h-1.136v.463h1.136v1.132h.462v-1.132h1.135zM107.735 149.303H106.6v-1.136h-.462v1.136h-1.136v.462h1.136v1.133h.462v-1.133h1.135zM164.493 11.428h-.518v-.518h-.21v.518h-.517v.209h.517v.518h.21v-.518h.518zM238.243 58.928h-.518v-.518h-.21v.518h-.517v.21h.517v.517h.21v-.517h.518zM194.743 89.927h-.518v-.517h-.21v.517h-.517v.211h.517v.517h.21v-.517h.518zM17.742 109.427h-.517v-.517h-.21v.517h-.518v.211h.518v.517h.21v-.517h.517zM38.992 151.928h-.517v-.518h-.21v.518h-.517v.209h.517v.518h.21v-.518h.517zM105.743 17.677h-.518v-.517h-.21v.517h-.517v.21h.517v.518h.21v-.518h.518zM74.243 92.427h-.518v-.517h-.21v.517h-.517v.211h.517v.517h.21v-.517h.518zM80.993 70.927h-.518v-.517h-.21v.517h-.517v.211h.517v.517h.21v-.517h.518z"
}), React.createElement("circle", {
  cx: 3.038,
  cy: 2.913,
  r: 2.88,
  fill: "url(#8base-cli-login_svg__b)",
  fillRule: "nonzero",
  opacity: 0.7,
  transform: "translate(184.25 114.75)"
}), React.createElement("circle", {
  cx: 187.287,
  cy: 117.662,
  r: 2.667,
  fill: "#000",
  fillRule: "nonzero",
  opacity: 0.2
}), React.createElement("circle", {
  cx: 194.47,
  cy: 136.44,
  r: 2.982,
  fill: "#000",
  fillRule: "nonzero",
  opacity: 0.2
}), React.createElement("path", {
  fill: "url(#8base-cli-login_svg__c)",
  fillRule: "nonzero",
  d: "M150.51 56.583a8.582 8.582 0 1 0-6.847 13.767c.182 0 .364 0 .542-.02a8.58 8.58 0 0 0 6.307-13.733l-.002-.014z"
}), React.createElement("path", {
  fill: "#000",
  fillRule: "nonzero",
  d: "M151.773 61.752a8.113 8.113 0 0 1-7.6 8.095c-.168 0-.34.018-.513.018a8.115 8.115 0 1 1 4.058-15.14 8.147 8.147 0 0 1 2.415 2.14 8.075 8.075 0 0 1 1.64 4.887z",
  opacity: 0.2
}), React.createElement("path", {
  fill: "#000",
  fillRule: "nonzero",
  d: "M141.662 56.605a8.72 8.72 0 0 0-1.21.638c-.257.14-.479.339-.647.58a.75.75 0 0 0-.015.827c.198.27.578.31.912.33.352.045.71.009 1.046-.105a2.25 2.25 0 0 0 .61-.443l.697-.632c.25-.22.5-.522.403-.832a.75.75 0 0 0-.593-.4 2.48 2.48 0 0 0-1.75.307",
  opacity: 0.1
}), React.createElement("circle", {
  cx: 0.5,
  cy: 0.455,
  r: 1,
  fill: "#000",
  fillRule: "nonzero",
  opacity: 0.1,
  transform: "translate(138.25 64.5)"
}), React.createElement("circle", {
  cx: 1.68,
  cy: 1.75,
  r: 1.565,
  fill: "#000",
  fillRule: "nonzero",
  opacity: 0.1,
  transform: "translate(145.75 60.5)"
}), React.createElement("path", {
  fill: "#000",
  fillRule: "nonzero",
  d: "M150.148 56.865a2.135 2.135 0 1 1-2.418-2.14 8.148 8.148 0 0 1 2.417 2.14zM150.292 66.422a8.093 8.093 0 0 1-6.12 3.426c0-.113-.015-.226-.015-.34a3.845 3.845 0 0 1 6.136-3.085z",
  opacity: 0.1
}), React.createElement("path", {
  fill: "url(#8base-cli-login_svg__d)",
  fillRule: "nonzero",
  d: "M79.69 102.895a6.037 6.037 0 0 0-1.785-1.58 6 6 0 1 0-3 11.175c.127 0 .25 0 .38-.012a6 6 0 0 0 4.4-9.583h.005z"
}), React.createElement("path", {
  fill: "#000",
  fillRule: "nonzero",
  d: "M80.57 106.502a5.66 5.66 0 0 1-5.302 5.648h-.358a5.66 5.66 0 1 1 2.83-10.563c.657.383 1.23.893 1.685 1.5a5.63 5.63 0 0 1 1.145 3.415z",
  opacity: 0.2
}), React.createElement("path", {
  fill: "#000",
  fillRule: "nonzero",
  d: "M73.515 102.912a5.875 5.875 0 0 0-.843.443c-.178.1-.333.238-.452.405a.533.533 0 0 0 0 .578c.168.165.4.25.635.23.246.031.495.006.73-.073.159-.078.303-.183.428-.31l.484-.44c.17-.155.356-.365.28-.58a.5.5 0 0 0-.412-.28 1.718 1.718 0 0 0-1.218.215",
  opacity: 0.1
}), React.createElement("circle", {
  cx: 0.482,
  cy: 0.485,
  r: 1,
  fill: "#000",
  fillRule: "nonzero",
  opacity: 0.1,
  transform: "translate(71 108.25)"
}), React.createElement("circle", {
  cx: 1.29,
  cy: 1.1,
  r: 1.093,
  fill: "#000",
  fillRule: "nonzero",
  opacity: 0.1,
  transform: "translate(76.25 105.75)"
}), React.createElement("path", {
  fill: "#000",
  fillRule: "nonzero",
  d: "M79.427 103.093a1.5 1.5 0 1 1-1.687-1.5 5.668 5.668 0 0 1 1.688 1.5zM79.537 109.76a5.648 5.648 0 0 1-4.27 2.39v-.25a2.683 2.683 0 0 1 4.28-2.153l-.01.013z",
  opacity: 0.1
}), React.createElement("path", {
  d: "M209.673 113.605l5.45 2.9-4.255 4.76"
}), React.createElement("circle", {
  cx: 238.975,
  cy: 85.808,
  r: 1,
  fill: "#FFF",
  fillRule: "nonzero"
})), React.createElement("g", {
  fillRule: "nonzero",
  transform: "rotate(60 113.356 175.844)"
}, React.createElement("path", {
  fill: "#EA4235",
  d: "M31.408 168.088c-.757.134-1.498.346-2.212.631-15.907 6.353-15.642 47.935-15.642 47.935H8.871S7.396 198.81.971 173.35c-5.79-22.906 17.954-43.434 22.775-47.327a56.4 56.4 0 0 1 .844-.664c23.914 8.789 6.818 42.73 6.818 42.73z"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M26.33 126.08a23.122 23.122 0 0 0-1.725-.716s-.295.23-.844.664C18.94 129.92-4.804 150.449.985 173.355c6.426 25.46 7.886 43.3 7.886 43.3h2.634s-1.46-17.846-7.901-43.306c-5.766-22.8 17.748-43.252 22.726-47.268z",
  opacity: 0.2
}), React.createElement("path", {
  fill: "#EA4235",
  d: "M110.309 173.355c-6.441 25.46-7.892 43.3-7.892 43.3h-4.692s.295-43.46-16.73-48.31a9.299 9.299 0 0 0-1.124-.263s-17.105-33.941 6.818-42.724c0 0 .242.18.679.531 4.432 3.548 28.795 24.295 22.94 47.466z"
}), React.createElement("path", {
  fill: "#000",
  d: "M31.408 168.088c-.757.134-1.498.346-2.212.631a288.78 288.78 0 0 1-5.45-42.691 56.4 56.4 0 0 1 .844-.664c23.914 8.783 6.818 42.724 6.818 42.724zm55.969-42.193a265.716 265.716 0 0 1-6.374 42.467 9.298 9.298 0 0 0-1.123-.262s-17.105-33.942 6.818-42.724c-.009-.012.233.168.679.519z",
  opacity: 0.1
}), React.createElement("path", {
  fill: "#E3E8F4",
  d: "M78.62 174.523a321.633 321.633 0 0 1-5.806 20.054s-10.534 10.974-35.98 0c0 0-2.542-7.166-5.337-19.35-6.155-26.786-13.537-77.832 2.19-130.265A195.158 195.158 0 0 1 53.5 0s13.436 15.427 23.298 44.953c9.862 29.527 16.138 73.16 1.823 129.57z"
}), React.createElement("circle", {
  cx: 55.638,
  cy: 86.586,
  r: 21.125,
  fill: "#AFC0E0"
}), React.createElement("path", {
  fill: "#4DA1FF",
  d: "M70.96 86.979a14.981 14.981 0 0 1-24.478 11.587 15.138 15.138 0 0 1-3.774-4.636A14.952 14.952 0 0 1 41 86.979v-.357a15 15 0 0 1 10.912-14.073 15.492 15.492 0 0 1 3.61-.549h.448a14.982 14.982 0 0 1 14.99 14.979z"
}), React.createElement("path", {
  fill: "#EA4235",
  d: "M76.795 44.953c-23.967 11.475-43.122 0-43.122 0A195.158 195.158 0 0 1 53.5 0s13.436 15.427 23.295 44.953zm1.826 129.57a316.49 316.49 0 0 1-3.746 13.463c-.653 2.176-1.34 4.37-2.064 6.582 0 0-10.534 10.974-35.98 0 0 0-.825-2.327-2.064-6.582a241.426 241.426 0 0 1-3.282-12.767s9.472 4.043 22.917 4.043a63.144 63.144 0 0 0 24.219-4.739z"
}), React.createElement("path", {
  fill: "#E3E8F4",
  d: "M74.875 187.986c-.653 2.176-1.34 4.37-2.064 6.582 0 0-10.534 10.974-35.98 0 0 0-.825-2.327-2.064-6.582-.003 0 25.932 7.461 40.108 0z"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M51.58 72.147l-.032.024-10.883 14.05v.356a14.952 14.952 0 0 0 1.708 6.951l12.823-21.93-3.616.55zm3.474 12.681l-8.912 13.345a15.138 15.138 0 0 1-2.808-3.046L53.951 83.73l1.103 1.097z",
  opacity: 0.2
}), React.createElement("path", {
  fill: "#FFF",
  d: "M42.526 194.571s-2.542-7.17-5.338-19.349c-6.154-26.79-13.536-77.836 2.192-130.269A195.875 195.875 0 0 1 56.735 4.23C54.74 1.43 53.491.003 53.491.003a195.137 195.137 0 0 0-19.818 44.95c-15.728 52.433-8.346 103.48-2.191 130.269 2.796 12.18 5.338 19.35 5.338 19.35 10.053 4.331 17.777 5.24 23.445 4.756-4.842-.369-10.723-1.734-17.739-4.757z",
  opacity: 0.2
}), React.createElement("g", {
  transform: "translate(39.5 71)"
}, React.createElement("ellipse", {
  cx: 15.958,
  cy: 15.819,
  fill: "#EA4235",
  rx: 15.958,
  ry: 15.819
}), React.createElement("path", {
  fill: "#FFF",
  d: "M15.958 26.747c-3.776 0-7.096-3.019-7.096-6.822 0-2.325 1.097-4.197 3.167-5.283-1.187-1.148-1.888-2.295-1.888-3.985 0-3.26 2.528-5.797 5.817-5.797 3.29 0 5.847 2.536 5.847 5.797 0 1.69-.73 2.837-1.918 3.985 2.07 1.086 3.167 2.958 3.167 5.283-.03 3.803-3.32 6.822-7.096 6.822zm0-10.053c-1.797 0-3.259 1.45-3.259 3.23 0 1.782 1.462 3.23 3.259 3.23s3.259-1.448 3.259-3.23c0-1.78-1.462-3.23-3.259-3.23zm0-8.241c-1.249 0-2.223 1.056-2.223 2.264 0 1.208 1.005 2.234 2.223 2.234s2.254-1.026 2.254-2.234a2.264 2.264 0 0 0-2.254-2.264z"
}))));

var Svg8BaseCliLogin = function Svg8BaseCliLogin(props) {
  return React.createElement("svg", _extends({
    width: 285,
    height: 187
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/8base-cli-login.e8d92e75.svg";
export { Svg8BaseCliLogin as ReactComponent };